import { Component, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Toast, ToastService } from './services/ui-toast.service';

@Component({
  selector: 'black-ui-toast',
  templateUrl: './ui-toast.component.html',
  styleUrl: './ui-toast.component.css',
  standalone: false,
})
export class UiToastComponent {
  private toastService = inject(ToastService);

  toasts$: Observable<Toast[]>;

  constructor() {
    this.toasts$ = this.toastService.toasts$;
  }
}
